import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import DataTable from '../components/DataTable';
import { activityLogs } from '../data/dummyData';

const ActivityLogs = () => {
  const [logList] = useState(activityLogs);

  const columns = [
    { key: 'action', label: 'Action', sortable: true },
    { key: 'detail', label: 'Detail', sortable: false },
    { key: 'user', label: 'User', sortable: true },
    { key: 'timestamp', label: 'Timestamp', sortable: true },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Activity Logs"
        description="Track all admin activities"
        breadcrumbs={['Home', 'Logs']}
      />

      <DataTable
        columns={columns}
        data={logList}
        searchable={true}
        paginate={true}
        itemsPerPage={10}
      />
    </div>
  );
};

export default ActivityLogs;
